import { t } from 'i18next'

import AdsTable from '~/modules/retailMedia/components/_tables/AdsTable'
import CampaignsPageHeader from '~/modules/retailMedia/components/CampaignsPageHeader'
import DashboardRetailMediaCampaigns from '~/modules/retailMedia/components/DashboardRetailMediaCampaigns'
import { ImpressionShareNewsAlert } from '~/modules/retailMedia/components/ImpressionShareNewsAlert'
import MainTabs from '~/modules/retailMedia/components/MainTabs'
import RoasCalculationAlerts from '~/modules/retailMedia/components/RoasCalculationAlerts'

import AdListFilters from '../../components/_tables/AdListFilters'

const RetailMediaAdsDashboard = () => (
  <>
    <CampaignsPageHeader
      section={t('rm:Ads')}
      dashboardTitle={t('rm:AdsDashBoard')}
    />

    <MainTabs />

    <ImpressionShareNewsAlert />
    <RoasCalculationAlerts />

    <AdListFilters />

    <DashboardRetailMediaCampaigns origin="ads" />

    <AdsTable />
  </>
)

export default RetailMediaAdsDashboard
